import './index.less';
import File from './File';
File.install = function(Vue) {
  Vue.component(File.name, File);
};

export default File;
